import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-rate-config-popup',
  templateUrl: './rate-config-popup.component.html',
  styleUrls: ['./rate-config-popup.component.scss']
})
export class RateConfigPopupComponent implements OnInit {
  @Input() tooltipInfo: string = 'Настройка ставки';
  @Input() title: string = 'Настройка ставки';
  @Input() nameColumn: string = 'Количество';
  @Input() rateString: string = '';
  @Output() saved = new EventEmitter<string>();
  @Output() closed = new EventEmitter<void>();
  visible = false;
  rates: { id: number, threshold: number, value: number }[] = [];

  constructor() { }
  ngOnInit(): void {
    this.parseRateString(this.rateString);
    document.body.style.overflow = 'hidden'; // Блокирует скролл на body
    document.body.style.touchAction = 'none'; // Для мобильных устройств
  }


  addRate() {
    const newId = this.rates.length > 0 ? this.rates.length : 0

    const lastThreshold = this.rates.length > 0
      ? Math.max(...this.rates.map(r => r.threshold)) + 1
      : 0;

    this.rates.push({ id: newId, threshold: lastThreshold, value: 0 });

  }


  validateInput(event: KeyboardEvent, field: 'threshold' | 'value') {
    const input = event.target as HTMLInputElement;
    const key = event.key;

    const allowedKeys = [
      'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight',
      'Delete', 'Home', 'End'
    ];

    if (!/\d/.test(key) && !allowedKeys.includes(key)) {
      event.preventDefault();
      return;
    }

    if (event.ctrlKey && key.toLowerCase() === 'v') {

    }
  }

  close() {
    document.body.style.overflow = '';
    document.body.style.touchAction = ''
    this.closed.emit();
  }

  save() {
    document.body.style.overflow = '';
    document.body.style.touchAction = ''
    let result = this.rates
      .sort((a, b) => a.threshold - b.threshold)
      .map(r => `${r.threshold}=${r.value}`)
      .join(';');
    if (!result || result === '') {
      result = "0=0"
    }
    this.saved.emit(result);
  }

  removeRate(index: number) {
    this.rates.splice(index, 1);
  }
  validateThresholds(): boolean {
    const thresholdValues = this.rates.map(rate => rate.threshold);
    const uniqueValues = new Set(thresholdValues);

    // Проверяем, что количество уникальных значений равно общему количеству
    return uniqueValues.size === thresholdValues.length;
  }
  private parseRateString(rateStr: string) {
    this.rates = rateStr.split(';')
      .filter(item => item.includes('='))
      .map((item, index) => {
        const [t, v] = item.split('=');
        return {
          id: index,
          threshold: Math.max(0, parseInt(t, 10) || 0),
          value: Math.max(0, parseInt(v, 10) || 0)
        };
      });

    if (this.rates.length === 0) {
      this.rates.push({ id: 0, threshold: 0, value: 0 });
    }

  }
}